import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function BookingCTA() {
  return <section className="py-24 bg-jet relative border-y border-burgundy/20" data-id="element-39">
      <div className="absolute inset-0 pattern-dots opacity-20" data-id="element-40"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border border-burgundy/30 p-8 md:p-16 rounded-2xl bg-jet/80 backdrop-blur-md" data-id="element-42">
          <h2 className="text-4xl md:text-6xl font-heading font-bold text-cream mb-6 text-glow" data-id="element-43">
            Ready to Transform Your Look?
          </h2>
          <p className="text-cream/70 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-44">
            Secure your spot today. Our calendar fills up quickly.
          </p>
          <a href="tel:2409217857" className="inline-block" data-id="element-45">
            <Button size="lg" className="text-sm md:text-lg px-6 md:px-12 whitespace-nowrap flex items-center justify-center w-full sm:w-auto" data-id="element-46">
              <PhoneIcon className="w-4 h-4 md:w-5 md:h-5 mr-2 shrink-0" data-id="element-47" /> Call
              Now — (240) 921-7857
            </Button>
          </a>
          <p className="mt-6 text-sm text-cream/50" data-id="element-48">
            Walk-ins welcome • No appointment needed
          </p>
        </motion.div>
      </div>
    </section>;
}